import { useEffect, useRef, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import management from '../utils/management.svg'
import copy from '../utils/copy.svg'
import tick from '../utils/tick.svg'

function Home() {
    const [isBuyNow, setIsBuyNow] = useState(false);
    const [isBTC, setIsBTC] = useState(false);
    const [isTx, setIsTx] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isAmount, setIsAmount] = useState(false);
    const [isAddress, setIsAddress] = useState(false);
    const [purchase, setPurchase] = useState({
        name: null,
        email: null
    });
    const home = isBuyNow ? "home blur" : "home";
    const emailRegex = /\S+@\S+\.\S+/;
    const email = useRef();
    const name = useRef();
    const txId = useRef();

    function handleBuy() {
        setIsBuyNow(true);
    }

    function handleClose (event) {
        if (
            (event.target.matches(".modal-close") ||
            !event.target.closest(".modal")) &&
            !event.target.matches(".modal-btn")
        ) {
            setIsBuyNow(false)
        }
    }

    function handleToast(text) {
        toast.error(text, {
            iconTheme: {
                primary: '#fff',
                secondary: '#000',
            },
        });
    }

    function handleFirstNext() {
        if (name.current.value.length <= 2) {
            return handleToast("Name is too small");
        }

        if (!emailRegex.test(email.current.value)) {
            return handleToast("Email address is incorrect");
        }
        setPurchase({
            name: name.current.value,
            email: email.current.value
        })

        setIsBTC(true)
    }

    function handleSecondNext() {
        setIsTx(true);
    }

    function handleSubmit() {
        if (txId.current.value.length <= 32) {
            return handleToast("Transaction id is incorrect");
        }
        setIsSuccess(true);

        const purchaseData = {
            name: purchase.name,
            email: purchase.email,
            txId: txId.current.value
        };
        console.log(purchaseData);
        fetch(`${process.env.REACT_APP_API_URL}/team-face/purchase`, {
            method: 'POST',
            body: JSON.stringify(purchaseData),
        })
        .then(function (response) {
            response.json().then(function (data) {
                console.log(data);
            })
            .catch((error) => {
                console.error('Error while saving purchase data:', error);
            });
        })
    }

    function handleAmount() {
        navigator.clipboard
        .writeText("0.001")
        .catch((err) => {
          console.log("Something went wrong while copying amount", err);
        });
        setIsAmount(true);
    }

    function handleAddress() {
        navigator.clipboard
        .writeText("32HGDkUQuvLHbPTX9bT3FmZZ3aFfndTP3A")
        .catch((err) => {
          console.log("Something went wrong while copying address", err);
        });
        setIsAddress(true)
    }

    useEffect(() => {
        if(isBuyNow) {
            document.addEventListener("click", handleClose, false);
        }

        return () => {
            document.removeEventListener("click", handleClose, false);
        }
    }, [isBuyNow])

    return(
        <>
        <Toaster position="top-center" reverseOrder={false}
            toastOptions={{
                success: {
                    style: {
                        background: 'green',
                        color: 'white',
                    },
                },
                error: {
                    style: {
                        background: 'red',
                        color: 'white',
                    },
                },
            }}
        />
        {isBuyNow ?
        isSuccess ?
        <div className="modal modal-aspect">
            <div className="modal-close">x</div>
            <div>
                <h3 className="success"><span className="thanks">Thanks!</span> You'll receive the Team<span className="face">Face</span> software via email, after the transaction will be confirmed on the blockchain.</h3>
            </div>
        </div> :
        isTx ?
        <div className="modal modal-aspect">
            <div className="modal-close">x</div>
            <div>
                <input type="text" placeholder="Paste Transaction Id" ref={txId} />
            </div>
            <div>
                <button className="modal-btn" onClick={handleSubmit}>Submit</button>
            </div>
        </div> :
        isBTC ?
        <div className="modal modal-aspect modal-btc">
            <div className="modal-close">x</div>
            <div>
                <h3>Transfer following amount to the given address</h3>
                <p onClick={handleAmount}>0.001 BTC <img src={isAmount ? tick: copy} alt="Copy" className="copy" /></p>
                <p onClick={handleAddress}>32HGDkUQuvLHbPTX9bT3FmZZ3aFfndTP3A <img src={isAddress ? tick: copy} alt="Copy" className="copy" /></p>
            </div>
            <div>
                <button className="modal-btn" onClick={handleSecondNext}>Next</button>
            </div>
        </div> : 
        <div className="modal modal-aspect">
            <div className="modal-close">x</div>
            <div>
                <input type="text" placeholder="Name" ref={name} />
            </div>
            <div>
                <input type="email" placeholder="Email Address" autoComplete="email" ref={email} />
            </div>
            <div>
                <button className="modal-btn" onClick={handleFirstNext}>Next</button>
            </div>
        </div> : null }
        <div className={home}>
            <div className="wrapper">
                <div className="header">
                    <div>
                        <h1>Team<span className="face">Face</span></h1>
                    </div>
                    <div>
                        <button onClick={handleBuy}><h3>Buy now</h3></button>
                    </div>
                </div>
            </div>
            <div className="content">
                <div>
                    <div className="title">Managing Team Simplified</div>
                    <div className="description">What if we combine tasks, team and security together? You'll get a powerful, self-hosted, agile management software that scales with you</div>
                </div>
                <div>
                    <img src={management} alt="Management" />
                </div>
            </div>
            <div className="feature">
                <div>
                    <div>
                        <img src='/assets/projects.png' alt="Projects" className="feature-img" />
                    </div>
                    <div>
                        <div className="title">Projects</div>
                        <div className="description">
                            <ul>
                                <li>Establish your teams or tasks and invite registered people to join them.</li>
                                <li>Projects are accessible to members.</li>
                                <li>The admin of the application or workgroup will be the originator user.</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <div className="title">Tasks</div>
                        <div className="description">
                            <ul>
                                <li>An administrator can create a task and distribute it to others as well as to himself.</li>
                                <li>By clicking on a task, members may view its start and finish times.</li>
                                <li>Members can alter the status of their own assignments by dragging and dropping them.</li>
                                <li>Only the administrator has the ability to add/remove tasks from "Done," "Blocked," and "Deleted".</li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <img src='/assets/tasks.png' alt="Tasks" className="feature-img" />
                    </div>
                </div>
                <div>
                    <div>
                        <img src='/assets/calendar.png' alt="Calendar" className="feature-img" />
                    </div>
                    <div>
                        <div className="title">Calendar</div>
                        <div className="description">
                            <ul>
                                <li>Task deadlines will be displayed on the calendar.</li>
                                <li>Only the administrator has the ability to drag and drop projects in the calendar to modify their deadline.</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <div className="title">Report</div>
                        <div className="description">
                            <ul>
                                <li>The user can check the status of all his/her projects.</li>
                                <li>As well as his/her own status in all the projects.</li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <img src='/assets/report.png' alt="Report" className="feature-img report-img" />
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default Home;